import PrinterIcon from "@redotech/redo-icons/printer.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { FilterCatalogEntry } from "@redotech/redo-model/views/fulfillment/filter-catalog-entry";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const PrinterFilter = (
  entry: FilterCatalogEntry & { type: AdvancedFilterType.BOOLEAN },
  label: string,
): BooleanTableFilter => ({
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  displayName: entry.displayName,
  label,
  boolDisplay: { falseDisplay: "unprinted", trueDisplay: "printed" },
  Icon: PrinterIcon,
});
